

exports.isValidPhone = phone => {
    
  if(!phone)
  return null;
  
    const phoneRegexDDD = /^((1[1-9])|(2[12478])|(3[1234578])|(4[1-9])|(5[1345])|(6[1-9])|(7[134579])|(8[1-9])|(9[1-9]))9[0-9]{8}$/;
    const rawPhone = phone.replace(/\s/g, '')
    const rawPhSfx = rawPhone.slice(2)
    const invalidPhones = ['000000000','111111111','222222222','333333333','444444444','555555555','666666666','777777777','888888888','999999999'];
    const invalid = invalidPhones.filter( i => rawPhone.endsWith(i))

    // console.log(rawPhone)
    // console.log(invalid)

    if(invalid.length > 0 ||  rawPhSfx[0] !=='9'){
      return 'Telefone inválido, informe o telefone corretamente.';
    }else if (!phoneRegexDDD.test(rawPhone)){
      return 'Telefone inválido. Seu DDD está correto?';
    }
    return null;
  }

  /* Dados de teste para regex de telefone que valida DDD - variavel phoneRegexDDD

  31909999999
31989999999	
11984595462
12984595462
13984595462
14984595462
15984595462
16984595462
17984595462
18984595462
19984595462
21984595462
22984595462
24984595462
27984595462
28984595462
31984595462
32984595462
33984595462
34984595462
35984595462
37984595462
38984595462
41984595462
42984595462
43984595462
44984595462
45984595462
46984595462
47984595462
48984595462
49984595462
51984595462
53984595462
54984595462
55984595462
61984595462
62984595462
63984595462
64984595462
65984595462
66984595462
67984595462
68984595462
69984595462
71984595462
73984595462
74984595462
75984595462
77984595462
79984595462
81984595462
82984595462
83984595462
84984595462
85984595462
86984595462
87984595462
88984595462
89984595462
91984595462
92984595462
93984595462
94984595462
95984595462
96984595462
97984595462
98984595462
99984595462

*/